var map = {
	"./icon_ai_60x60px.svg": 9409,
	"./icon_ai_plus_60x60px.svg": 7584,
	"./icon_check_60x60px.svg": 5488,
	"./icon_date_60x60px.svg": 6149,
	"./icon_margin_60x60px.svg": 9294,
	"./icon_media_budget_60x60px.svg": 5327,
	"./icon_naming_60x60px.svg": 9879,
	"./icon_optimization_60x60px.svg": 1378,
	"./icon_pay_factor_60x60px.svg": 2895,
	"./icon_security_60x60px.svg": 6484,
	"./icon_summary_60x60px.svg": 669,
	"./icon_szenario_60x60px.svg": 4718,
	"./icon_template_60x60px.svg": 8757,
	"./icon_time_60x60px.svg": 1989,
	"./icon_verification_60x60px.svg": 7039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9461;